export default __webpack_public_path__ + "static/media/lowStock.9725d37b.svg";